import React, { Component } from 'react';
import "./newgraduate.css";
import mainFeature from '../../assets/images/fourposition/feature1.jpeg';
import feature2 from "../../assets/images/fourposition/feature2.jpeg";
import feature3 from "../../assets/images/fourposition/feature3.jpeg";
import feature4 from "../../assets/images/fourposition/feature4.jpeg";
import { Helmet } from 'react-helmet-async';

class Programmer extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>採用情報 | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div className='container-box banner-container graduate_banner'>
                    <div className='overlay'></div>
                    <div className='row'>
                        <div className='col'>
                            <h1>採用情報</h1>
                            <h3>RECRUITMENT</h3>
                        </div>
                    </div>
                </div>
                <div className="container-box">
                    <div className="row row-title">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-md-8 col-lg-5 col-xl-6">
                            <h1 className='text-orange'>中途採用／プログラマー</h1>
                            <h5>MID-CAREER RECRUITMENT / PROGRAMMER</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-6">
                            <img src={mainFeature} alt="feature" className="img-fluid" />
                        </div>
                        <div className="col-sm-12 col-md-12 col-lg-6 main_feature_text p-4">
                            <h4>システム開発のすべてを手掛けられる魅力</h4><br />
                            <p>お客様から「こんなシステムを実現したい」との要望を聞き、システムの企画・仕様の提案から開発・保守メンテナンスまで一貫して行っています。
                                自社開発の環境が整っており、本社にいる場合でも直接お客様から電話が
                                かかってきて一緒に要件をつめ、課題を解決していくため、
                                自らの手で開発したシステムという実感を強く持てます。 無事稼働しお客様から「ありがとう」と感謝の言葉をいただけた時の喜びは格別です。</p>
                        </div>
                    </div>
                    <div className="row sub_features">
                        <div className="col-sm-12 col-md-12 col-lg-4 p-3 ">
                            <div className="card">
                                <div className="card-img">
                                    <img src={feature2} alt="team feature" className="img-fluid card-img-top" />
                                </div>
                                <div className="card-body">
                                    <p className="feature_description card-text">何らかのシステム開発経験がある方で開発が好き、自分の仕事により、たくさんの人々を喜ばせたい方はぜひ！</p>
                                </div>
                            </div>

                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-4 p-3 ">
                            <div className="card">
                                <div className="card-img">
                                    <img src={feature3} alt="time feature" className="img-fluid card-img-top" />
                                </div>
                                <div className="card-body">
                                    <p className="feature_description card-text">残業月12時間程度、プロジェクトチーム毎に早く帰る工夫をしています。<br />
                                        9:00～18:00（実働：8時間）</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-4 p-3 ">
                            <div className="card">
                                <div className="card-img">
                                    <img src={feature4} alt="leadership feature" className="img-fluid card-img-top" />
                                </div>
                                <div className="card-body">
                                    <p className="feature_description card-text">プロジェクトマネジメントやリーダーシップなどのヒューマンスキルに関する研修も積極的に受講することができます。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container-box mb-5">
                    <div className="row row-title">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-md-4">
                            <h1 className='text-blue'>募集詳細</h1>
                            <h5>RECRUITMENT DETAILS</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <table className="csz_table csz_table_blue">
                        <tbody>
                            <tr>
                                <th>募集職種</th>
                                <td>プログラマー</td>
                            </tr>
                            <tr>
                                <th>募集背景</th>
                                <td>世界トップクラスの東海地区のモノづくりを支えるシステム開発を行い、社員数100名、売上高10億円を目指して今後の会社の中核を担う、新たな仲間を募集しています。</td>
                            </tr>
                            <tr>
                                <th>応募資格</th>
                                <td>
                                    何等かのシステム開発経験がある方<br />
                                    ＊経験の浅い方も歓迎です
                                </td>
                            </tr>
                            <tr>
                                <th>勤務地</th>
                                <td>
                                    ①本社<br />
                                    名古屋市内及び近郊（東京支社勤務も可能）<br /><br />
                                    ②東京<br />
                                    東京支社または東京都内及び近郊
                                </td>
                            </tr>
                            <tr>
                                <th>募集</th>
                                <td>随時募集</td>
                            </tr>
                            <tr>
                                <th>給与</th>
                                <td>
                                    月給：22万円～35万円<br />
                                    ＊資格・経験等考慮のうえ、優遇します
                                </td>
                            </tr>
                            <tr>
                                <th>手当</th>
                                <td>
                                    時間外手当 (全額支給)<br />
                                    通勤手当 (全額支給)<br />
                                    住宅手当 (該当者のみ)<br />
                                    家族手当 (該当者のみ)<br />
                                    ＊地域手当（②東京支社勤務の場合）
                                </td>
                            </tr>
                            <tr>
                                <th>給与例</th>
                                <td>
                                    【年収例】<br />
                                    420万円/入社5～8年目/月給30万円＋賞与<br />
                                    370万円/入社3～5年目/月給25万円＋賞与
                                </td>
                            </tr>
                            <tr>
                                <th>昇給</th>
                                <td>年1回 (11月)</td>
                            </tr>
                            <tr>
                                <th>賞与</th>
                                <td>年2回 (7月・12月)</td>
                            </tr>
                            <tr>
                                <th>勤務時間</th>
                                <td>9:00 ～ 18:00 (12:00～13:00 休憩)</td>
                            </tr>
                            <tr>
                                <th>休日休暇</th>
                                <td>
                                    完全週休2日制 (土・日) ・祝日<br />
                                    年間休日122日以内<br />
                                    有給休暇 (6ヶ月経過後10日付与)<br />
                                    慶弔休暇・夏季休暇・年末年始休暇
                                </td>
                            </tr>
                            <tr>
                                <th>保険</th>
                                <td>健康保険・厚生年金・雇用保険・労災保険</td>
                            </tr>
                            <tr>
                                <th>福利厚生</th>
                                <td>福利厚生    退職金制度・育児介護休業制度・資格手当支給</td>
                            </tr>
                            <tr>
                                <th>応募方法</th>
                                <td>
                                    提出書類を送付して下さい<br />
                                    到着後、7日以内に選考しご連絡します
                                </td>
                            </tr>
                            <tr>
                                <th>提出書類</th>
                                <td>
                                    履歴書、職務経歴書<br />
                                    ※ 個人情報につきましては当社の採用活動以外での利用は致しません
                                </td>
                            </tr>
                            <tr>
                                <th>選考方法</th>
                                <td>書類選考、適性検査、一次面接、最終面接</td>
                            </tr>
                            <tr>
                                <th>問い合せ先</th>
                                <td>
                                    ①本社<br />
                                    TEL:　052-433-7796<br />
                                    jinjinal@nalsoft.co.jp<br />
                                    採用担当：経営業務部　採用担当<br />
                                    <br />
                                    ②東京<br />
                                    TEL:　050-3816-7622<br />
                                    jinjinal@nalsoft.co.jp<br />
                                    採用担当：経営業務部　採用担当
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="entry_section">
                    <div className="entry_content">
                        <h1 className="entry_content_header">エントリーはこちら！</h1>
                        <a className="entry_content_button" href="/recruit-form">応募フォーム</a>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default Programmer;